import { pricing } from "./pricing";

const byId = (id) => pricing.find((tier) => tier.id === id);

/*
  Home page teaser: three simple entry points with starting prices.
  Billing details (one-time vs setup + maintenance) live on the pricing page.
*/
export const teaser = [
  {
    id: "maps",
    icon: "pin",
    theme: "teal",
    name: "Google Business Profile",
    tagline: "Get found by nearby customers.",
    priceLabel: "Starts at",
    price: byId("starter").price,
    originalPrice: byId("starter").originalPrice,
    points: [
      "Profile setup and verification",
      "Correct placement on Google Maps",
      "Details optimised to rank locally",
    ],
    cta: { label: "See pricing", href: "/pricing" },
    featured: false,
  },
  {
    id: "websites",
    icon: "code",
    theme: "blue",
    name: "Showcase Website",
    tagline: "Put your business in the spotlight.",
    priceLabel: "Starts at",
    price: byId("intermediate").price,
    originalPrice: byId("intermediate").originalPrice,
    points: [
      "Fast, mobile-friendly design",
      "Products and services presented well",
      "Maps setup included",
    ],
    cta: { label: "See pricing", href: "/pricing" },
    featured: true,
  },
  {
    id: "software",
    icon: "pulse",
    theme: "navy",
    name: "Business software",
    tagline: "Nursing One and dialysis inventory software.",
    priceLabel: "Starts at",
    price: "₹28,499",
    originalPrice: "₹47,999",
    points: [
      "Nursing One: patient records and billing",
      "Dialysis inventory tracking",
      "Built around how your business works",
    ],
    cta: { label: "Explore products", href: "/products" },
    featured: false,
  },
];

export const teaserFooter = [
  "Free consultation",
  "No long contracts",
  "Full pricing on the pricing page",
];
